import { createFileRoute } from '@tanstack/react-router';
import { PortalAccessTab } from '../../../../features/B10/portal-access-tab';
import { useClientCtx } from '../../../../features/B4/ClientLayout';

/** D-129: "מרכז התראות ללקוח" — the client's staff accesses to the alerts center (lane B10). */
export const Route = createFileRoute('/_app/client/$clientId/portal')({
  component: PortalTab,
});

function PortalTab() {
  const { client } = useClientCtx();
  return <PortalAccessTab clientId={client.id} clientKind={client.kind} />;
}
